import React, { useState } from 'react';
import { X } from 'lucide-react';
import { useApiHandler } from '../../../utils/apiHandler';

function AddTaskModal({ project, onClose, onTaskAdded }) {
    const [newTask, setNewTask] = useState({
        title: '',
        description: '', // Add description
        assignedTo: [],
        status: 'Not Started',
        comments: [],
    });
    const apiHandler = useApiHandler();

    const handleAddTask = async () => {
        if (newTask.title && newTask.assignedTo.length > 0) {
            try {
                const taskData = {
                    employeeId: newTask.assignedTo[0],
                    projectId: project._id,
                    taskDetails: newTask.title,
                    description: newTask.description, // Include description
                };

                const response = await apiHandler.post('admin/assign-task', taskData);
                if (response.data.success) {
                    onTaskAdded(response.data.savedTask);
                    setNewTask({ title: '', description: '', assignedTo: [], status: 'Not Started', comments: [] });
                }
            } catch (error) {
                console.error('Error adding task:', error);
            }
        }
    };

    const handleEmployeeSelection = (employeeId) => {
        const updatedSelection = newTask.assignedTo.includes(employeeId)
            ? newTask.assignedTo.filter((id) => id !== employeeId)
            : [...newTask.assignedTo, employeeId];

        setNewTask({ ...newTask, assignedTo: updatedSelection });
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg max-w-md w-full p-6">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-medium text-gray-900">Add New Task</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
                        <X className="h-5 w-5" />
                    </button>
                </div>

                <div className="space-y-3">
                    <input
                        type="text"
                        placeholder="Task title"
                        className="w-full p-2 border rounded-lg"
                        value={newTask.title}
                        onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
                    />
                    <textarea
                        placeholder="Task description"
                        className="w-full p-2 border rounded-lg"
                        value={newTask.description}
                        onChange={(e) => setNewTask({ ...newTask, description: e.target.value })}
                    ></textarea>

                    <div>
                        <h4 className="font-medium text-gray-900 mb-2">Assign to Employees</h4>
                        <div className="space-y-2">
                            {project.Employeelist?.map((employee) => (
                                <div key={employee._id} className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id={`employee-${employee._id}`}
                                        checked={newTask.assignedTo.includes(employee._id)}
                                        onChange={() => handleEmployeeSelection(employee._id)}
                                        className="mr-2"
                                    />
                                    <label htmlFor={`employee-${employee.id}`} className="text-gray-900">
                                        {employee.employeeName}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <button
                        onClick={handleAddTask}
                        className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
                    >
                        Add Task
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AddTaskModal;
